import React, { useState } from "react";
import { useOffline } from "./OfflineProvider";

export default function SwUpdateToast() {
  const { swUpdate, actions } = useOffline();
  const [dismissed, setDismissed] = useState(false);
  if (!swUpdate.available || dismissed) return null;
  return (
    <div className="offline-toast" role="status">
      <span>Eine neue Version der Online-Doku ist verfügbar.</span>
      <div className="offline-toast-actions">
        <button type="button" className="offline-btn" onClick={() => actions.applyUpdate()}>Aktualisieren</button>
        <button type="button" className="offline-btn offline-btn--ghost" onClick={() => setDismissed(true)}>Später</button>
      </div>
    </div>
  );
}
